import { render, staticRenderFns } from "./TemplateView.vue?vue&type=template&id=00a6c730&scoped=true&"
import script from "./TemplateView.vue?vue&type=script&lang=js&"
export * from "./TemplateView.vue?vue&type=script&lang=js&"
import style0 from "./TemplateView.vue?vue&type=style&index=0&id=00a6c730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a6c730",
  null
  
)

export default component.exports